import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { fetchAuditLog } from '../../api/auditlog';
import './AuditLogPage.css';

// Journal d'audit cote company (Securite > Journal d'audit) : meme endpoint
// que la page superadmin (api/auditlog.js:fetchAuditLog) — le backend force
// deja la portee a CETTE company (AuditLogListView), pas de filtre `company`
// ici (n'aurait aucun effet, contrairement a la vue superadmin).
const ACTOR_TYPES = [
  { value: '', label: 'Tous' },
  { value: 'company', label: 'Company' },
  { value: 'company_user', label: 'Utilisateur company' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'sub_supervisor', label: 'Sub-supervisor' },
  { value: 'bank', label: 'Bank (POS)' },
  { value: 'superadmin', label: 'Superadmin' },
  { value: 'staff', label: 'Staff (limité)' },
];

const ACTIONS = [
  { value: '', label: 'Toutes' },
  { value: 'login', label: 'Login' },
  { value: 'create', label: 'Create' },
  { value: 'update', label: 'Update' },
  { value: 'delete', label: 'Delete' },
];

const fmtVal = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
};

const formatChanges = (changes) => {
  if (!changes) return '—';
  return Object.entries(changes).map(([k, v]) => (
    Array.isArray(v) && v.length === 2
      ? `${k}: ${fmtVal(v[0])} → ${fmtVal(v[1])}`
      : `${k}: ${fmtVal(v)}`
  )).join(', ');
};

const AuditLogPage = () => {
  const [rows, setRows] = useState([]);
  const [actorType, setActorType] = useState('');
  const [action, setAction] = useState('');
  const [modelName, setModelName] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = (params = {}) => {
    setLoading(true);
    setError('');
    fetchAuditLog(params)
      .then(setRows)
      .catch(() => setError('Chargement impossible.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const submit = (e) => {
    e.preventDefault();
    load({ actorType, action, modelName, dateFrom, dateTo });
  };

  const reset = () => {
    setActorType(''); setAction(''); setModelName(''); setDateFrom(''); setDateTo('');
    load();
  };

  return (
    <Layout>
      <p className="al-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/securite" className="bc-link">Securite</Link>
        {' >> '}
        <span className="bc-current">Journal d'audit</span>
      </p>

      <div className="al-card">
        <div className="al-card-header">
          <span className="al-card-title">Journal d'audit</span>
        </div>
        <div className="al-card-body">
          <form className="al-search" onSubmit={submit}>
            <select value={actorType} onChange={(e) => setActorType(e.target.value)}>
              {ACTOR_TYPES.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
            <select value={action} onChange={(e) => setAction(e.target.value)}>
              {ACTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
            <input
              type="text"
              placeholder="Modele (ex: Bank)"
              value={modelName}
              onChange={(e) => setModelName(e.target.value)}
            />
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
            <button type="submit" disabled={loading}>{loading ? '…' : 'Filtrer'}</button>
            <button type="button" onClick={reset}>Tout</button>
          </form>

          {error && <p className="al-error">{error}</p>}

          <table className="al-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Acteur</th>
                <th>Action</th>
                <th>Modèle</th>
                <th>Objet</th>
                <th>Détail</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && !loading && (
                <tr><td colSpan="6" className="al-empty">Aucune entrée.</td></tr>
              )}
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{new Date(r.created_at).toLocaleString()}</td>
                  <td>
                    <span className="al-actor-type">{r.actor_type}</span>
                    {' '}{r.actor_label}
                  </td>
                  <td>{r.action}</td>
                  <td>{r.model_name || '—'}</td>
                  <td>{r.object_repr || (r.object_id ?? '—')}</td>
                  <td className="al-changes">{formatChanges(r.changes)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default AuditLogPage;
